import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  Button,
  Typography,
  IconButton,
  CircularProgress,
  Box,
  Snackbar,
  Alert,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AnimatedPage from "../../animatedPage/AnimatedPage";
import styles from "../Login/styles.module.css";
import axios from "axios";

const ForgotPasswordModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("error");

  const handleCloseSnackbar = () => {
    setSnackbarOpen(false);
  };

  const handleSnackbarMessage = (message, type) => {
    setSnackbarMessage(message);
    setSnackbarSeverity(type);
    setSnackbarOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email) {
      return handleSnackbarMessage("Please enter your email", "error");
    }

    try {
      setLoading(true);
      const res = await axios.post("/api/Company/forgotPassword", { email });
      
      if (res.status === 200) {
        if (res?.data?.success) {
           handleSnackbarMessage("Reset link sent! Check your email.", "success");
        } else {
           handleSnackbarMessage(res?.data?.message, "error")
        }
      } else {
        handleSnackbarMessage("Something went wrong", "error")
      }
      setEmail("")
      setTimeout(() => {
        onClose()
      }, 3000);
    } catch (err) {
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        onClose={handleCloseSnackbar}
      >
        <Alert
          severity={
            snackbarSeverity === "success" ? undefined : snackbarSeverity
          }
          onClose={handleCloseSnackbar}
          sx={{
            width: "100%",
            backgroundColor:
              snackbarSeverity === "success" ? "#2196f3" : undefined, // Blue for success
            color: snackbarSeverity === "success" ? "#fff" : undefined, // White text for blue background
          }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
      <Dialog
        open={isOpen}
        onClose={onClose}
        maxWidth={false}
        PaperProps={{
          sx: {
            width: "500px", // 👈 match your login box width
            maxWidth: "95%", // responsive safety
            borderRadius: "16px",
            padding: "8px",
          },
        }}
        fullWidth
      >
        {/* Header */}
        <DialogTitle sx={{ m: 0, p: 2 }}>
          Forgot your password?
          <IconButton
            onClick={onClose}
            sx={{ position: "absolute", right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {/* Content */}
        <DialogContent>
          <Typography variant="body2" mb={2}>
            Enter your registered email address and we’ll send you a link to
            reset your password.
          </Typography>

          <form onSubmit={handleSubmit}>
            <TextField
              fullWidth
              label="Email Address"
              type="email"
              margin="normal"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />

            <Button
              fullWidth
              variant="contained"
              type="submit"
              disabled={loading}
              sx={{ mt: 2 }}
            >
              {loading ? <CircularProgress size={24} /> : "Send Reset Link"}
            </Button>
          </form>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default ForgotPasswordModal;
